// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2f-es","detailsBorder":"styles_detailsBorder__1Y01e"};